import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { format, isWithinInterval} from "date-fns";
import ptBR from "date-fns/esm/locale/pt-BR/";

import Accessibility from "../../../components/UI/Accessibility";
import ContentBox from "../../../components/UI/ContentBox";
import Footer from "../../../components/UI/Footer";
import Menu from "../../../components/UI/Menu";
import {
  Container,
  Item,
  ItemSelect,
  ItemForm,
  Text,
  Button,
  ButtonGroup,
  Finalizado,
  NFinalizado,
} from "./styles";

import {
  MdArrowBack,
} from "react-icons/md";

import Banner from "../../../components/UI/Banner";

import useApi from "../../../hooks/useApi";
import { useAuth } from "../../../hooks/useAuth";

import ReadMoreButton from "../../../components/UI/ReadMoreButton";
import FullScreenLoading from "../../../components/UI/FullScreenLoading";
import { images } from "../../../constants";

const ListFormsResponse = () => {

  const { id } = useParams();

  const navigate = useNavigate();
  const { user } = useAuth();

  const [listSchool, setListSchool] = useState([]);

  const [selectSchool, setSelectSchool] = useState({id:"",name:"",set:false});

  const [form, setForm] = useState([]);
  const [listFormResponse, setListFormResponse] = useState([]);

  const [loadForms, loadFormsInfo] = useApi({
      debounceDelay: 0,
      url: "canalPedagogico/form/completeForm",
      method: "get",
      onCompleted: (response) => {
        if (!response.error) {
          if(response.data.length>0){
            setForm(response.data[0]?.form);
            console.log("loadForms",response);
          }
        }
      },
    });

  const [createFormsResponse, createFormsResponseInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/form/response",
    method: "post",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("createFormsResponse",response);
        getListFormsResponse({
          params: {
            idform: id,
            idunity: selectSchool.id,
          },
        });
      }
      else{
        console.log("createFormsResponse error",response);
      }
    },
  });

  const [getListFormsResponse, getListFormsResponseInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/form/response",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("getListFormsResponse",response);
        setListFormResponse(response.data);
      }
      else{
        console.log("getListFormsResponse error",response);
      }
    },
  });

  useEffect(() => {
    if(id){
      loadForms({
        params: {
          idform: id,
        },
      });
    }

    if(user){
      let createListSchool = [];
      user.dados.unities.forEach((unity)=>{
        if(unity.linkedUnities.length>0){
          unity.linkedUnities.forEach((lUnity)=>{
            createListSchool.push({id:lUnity.idLinkedUnity,name:lUnity.linkedUnityName,set:true});
          });
        }
        else{
          createListSchool.push({id:unity.idUnity,name:unity.unityName,set:true});
        }
      });
      
      if(createListSchool.length===1){
        setSelectSchool(createListSchool[0]);
      }

      setListSchool(createListSchool);
      console.log("user",user);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if(id && selectSchool.id){
      getListFormsResponse({
        params: {
          idform: id,
          idunity: selectSchool.id,
        },
      });
    }
    // eslint-disable-next-line
  }, [id,selectSchool]);

  useEffect(() => {
    console.log("quantidade de formulario sem finalizar ",listFormResponse.filter((form)=>{return form.submitted===false}).length)
    // eslint-disable-next-line
  }, [listFormResponse]);

  useEffect(() => {
    console.log("form",form)
    // eslint-disable-next-line
  }, [form]);

  return (
    <Container>
      {(
        createFormsResponseInfo.loading ||
        loadFormsInfo.loading ||
        getListFormsResponseInfo.loading
      ) && <FullScreenLoading />}
      <Menu />
      <Banner icon={images.iconForms}>Avaliação de Contexto</Banner>
      <ContentBox>
        {selectSchool.id ? 
          <>
            <ItemSelect>UNIDADE:{listSchool.length>1&&<div><MdArrowBack  onClick={()=>{listSchool.length>1&&setSelectSchool({id:"",name:"",set:false})}} /></div>} {selectSchool.name}</ItemSelect>
            {/* <ItemSelect><div><MdArrowBack  onClick={()=>{setSelectSchool({id:"",name:"",set:false})}} /></div> {selectSchool.name}</ItemSelect> */}
            {listFormResponse.map((form)=><ItemForm key={form.idFormResponse} onClick={()=>{
              navigate(`/formularios/preencher/${form.idform}/${form.idFormResponse}`)
            }}>
              <div>Formulário criado em: {format(new Date(form.createdAt),"dd/MM/yyyy - HH:mm")}</div>
              {form.submitted?
              <div><Finalizado>Finalizado em: {format(new Date(form.submittedAt),"dd/MM/yyyy - HH:mm")}</Finalizado></div>:
              <div><NFinalizado>Não Finalizado</NFinalizado></div>}
            </ItemForm>)}
          </>
          :
          listSchool.map((school)=><Item key={`${school.id}-${school.name}`} onClick={()=>{setSelectSchool(school)}}>{school.name}</Item>)
        }

        {listSchool.length === 0 && <div>Usuário não possui escolas vinculadas a ele</div>}

        <ButtonGroup>
          <ReadMoreButton text={"Voltar"} onClick={()=>{
            navigate(`/formularios/listar/a825ead6-c54d-4956-a82a-3a0301dca109`)
          }}/>
          { selectSchool.id && listFormResponse.filter((form)=>{return form.submitted===false}).length===0 &&
            <ReadMoreButton text={"Criar novo registro de formulário"} onClick={()=>{
              if(form.idform && selectSchool.id){
                createFormsResponse({
                  data:{
                    idunity:selectSchool.id,
                    idform:form.idform,
                  }
                });
              }
            }}/>
          }
        </ButtonGroup>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default ListFormsResponse;
